import { Box, Skeleton } from "@saleor/macaw-ui-next";

export const HistoryComponentLoader = () => (
  <Box>
    <Skeleton __height="32px" __marginBottom="20px" />
    <Skeleton __height="16px" __marginBottom="18px" />
    <Skeleton __height="16px" __marginBottom="18px" />
    <Skeleton __height="16px" __marginBottom="18px" />
  </Box>
);
